namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_app, {

		Enter: {
			padding: '2rem',
		},
		Register: {
			padding: '2rem',
		},

		Tokens: {
			align: {
				content: 'center',
			},
		},

		Tokens_label: {
			justify: {
				content: 'center'
			},
		},
		Process_monitor_toggle_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},

		Book: {
			Menu: {
				Body_content: {
					gap: '1.5rem',
				},
				Foot: {
					flex: {
						direction: 'column',
					},
					gap: '0.5rem',
					padding: {
						left: '1.5rem',
						right: '1.5rem',
						bottom: '1rem',
					}
				},
				flex: {
					basis: '14rem',
				},
			},
		},

		Right_bottom_panel: {
			background: {
				color: 'transparent',
			},
			flex: {
				direction: 'column',
			},
			gap: '11px',
			pointerEvents: 'none',
			'>': {
				'$mol_view': {
					pointerEvents: 'auto',
				},
			},
			align: {
				items: "flex-end",
			},
			position: 'fixed',
			bottom: 0,
			right: 0,
			margin: $mol_gap.block,
			zIndex: 6,
		},

		Speech: {
			margin: {
				bottom: '3.5rem',
			},
		},

		Main: {
			flex: {
				grow: 1,
			},
			Head: {
				justify: {
					content: 'flex-start',
				},
				align: {
					content: 'center',
				},
				padding: {
					top: 0,
					bottom: 0,
				},
			},
		},

		Profile: {

			margin: {
				left: 'auto',
			},
			
			Enter_link: {
				align: {
					items: 'center',
				},
			},
	
			Register_link: {
				align: {
					items: 'center',
				},
			},

		},
		
	} )
	
}
